import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Storage } from "@ionic/storage";
// import { ApiService } from "../../services/api.service";

@Component({
  selector: 'page-company-user-terms',
  templateUrl: 'company-user-terms.html',
})
export class CompanyUserTermsPage {

  version = '';
  terms = '';

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      private storage: Storage,
      public viewCtrl: ViewController,
      public elem: ElementRef
  ) {
    this.version = navParams.get('version');
    this.terms = navParams.get('terms');
  }

  acceptTerms(){
    this.setHasAcceptedTerms(this.version).then(() => {
      this.closeModal();
    });
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  setHasAcceptedTerms(version){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.set('company_user_terms_accepted_' + user_id, version).then((val) => {
          resolve();
        })
      })
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/company-user-terms/company-user-terms.ts